import { search, search_documents, search_user } from '@modv/sdk' // get_recycled_objs

export default {
  namespaced: true,
  state: {
    documents: [],
    searchContents: {
      folders: [],
      documents: [],
      vaults: []
    },
    loadMoreDocuments: {},
    searchText: '',
    totalPages: 0,
    currentRoute: '',
    fresh: '',
    userResults: '',
    searchUser: {},
    clearQuery: false
  },
  getters: {
    searchText: (state) => state.searchText
  },
  mutations: {
    CLEAR_DOCUMENTS: (state, res) => {
      state.searchContents = res.data
    },
    UPDATE_DOCUMENT: (state, params) => {
      const document = state.searchContents.documents.filter((x) => x.id === params.documentId)[0]
      document.name = params.name
      document.lastModifiedOn = params.lastModifiedOn
    },
    SET_CURRENT_ROUTE: (state, res) => {
      state.currentRoute = res
    },
    SEARCH_CONTENTS: (state, res) => {
      state.totalPages = res.data.pageInfo.totalPages
      state.searchContents = res.data.data
      state.fresh = true
    },
    LOAD_MORE: (state, res) => {
      state.loadMoreDocuments = res.data.data
      state.fresh = false
    },
    SET_SEARCH_TEXT: (state, res) => {
      state.searchText = res
    },
    SEARCH_USER_RESULTS: (state, res) => {
      state.userResults = res.data
    },
    SET_SEARCH_USER: (state, params) => {
      state.searchUser = params.user
    },
    CLEAR_QUERY: (state, res) => {
      state.clearQuery = true
    }
  },
  actions: {
    setSearchText({ commit }, params) {
      commit('SET_SEARCH_TEXT', params.term)
    },
    async updateDocument({ commit }, params) {
      commit('UPDATE_DOCUMENT', {
        documentId: params.documentId,
        name: params.name,
        lastModifiedOn: params.lastModifiedOn
      })
    },
    clearDocuments({ commit }, params) {
      commit('CLEAR_DOCUMENTS', params)
    },
    async searchContents({ commit }, params) {
      commit('SET_CURRENT_ROUTE', params.currentRoute)
      commit(
        'SEARCH_CONTENTS',
        await search({
          term: params.term,
          pageNo: params.pageNo
        }),
        commit('SET_SEARCH_TEXT', params.term)
      )
    },
    async loadMore({ commit, dispatch }, params) {
      commit(
        'LOAD_MORE',
        await search_documents({
          term: params.term,
          pageNo: params.pageNo
        }),
        commit('SET_SEARCH_TEXT', params.term)
      )
    },
    async searchUser({ commit }, params) {
      const search = await search_user({
        searchText: params.searchText,
        pageNo: params.pageNo,
        itemsPerPage: params.itemsPerPage
      })
      commit('SEARCH_USER_RESULTS', search)
      return search.data.data
    }
  }
}
